import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FaPrint } from 'react-icons/fa'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

const INVITATION_PRINT_LINKS = {
  'birthday-jenine-charisse': '/debut/jenine-charisse/printable',
}

export default function PrintableInvite({ onUnavailableClose, purpose }) {
  const navigate = useNavigate()

  const [invitationId, setInvitationId] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const code = (localStorage.getItem('seat_checker_access_code') || '').trim()
    if (!code) return

    setLoading(true)
    ;(async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/rsvp/public-summary?code=${encodeURIComponent(code)}`)
        const j = await res.json().catch(() => ({}))
        if (res.ok && (j.invitationId || j.id)) {
          setInvitationId(j.invitationId || j.id)
        }
      } catch (err) {
        // Keep the dashboard usable even if the printable lookup fails.
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  function goToPrintable() {
    if (loading) return

    const link = invitationId ? INVITATION_PRINT_LINKS[invitationId] : null
    if (link) navigate(link)
  }

  const printableLink = invitationId ? INVITATION_PRINT_LINKS[invitationId] : null

  if (loading) {
    return (
      <div className="printable-invite-tool">
        <div className="printable-loading-panel">
          <div className="printable-icon" aria-hidden="true">
            <FaPrint />
          </div>
          <p className="printable-status">Resolving printable copy...</p>
        </div>
      </div>
    )
  }

  if (!printableLink) {
    return (
      <NoPrintableState onClose={onUnavailableClose} purpose={purpose} />
    )
  }

  return (
    <div className="printable-invite-tool">
      <div className="printable-hero">
        <div className="printable-icon" aria-hidden="true">
          <FaPrint />
        </div>

        <div className="printable-copy">
          <p className="printable-kicker">Printable version</p>
          <h2>Invitation</h2>
          <p>Open the print-ready copy for this invitation when it has been configured.</p>
        </div>

        <button className="btn primary printable-action" onClick={goToPrintable} disabled={loading}>
          <FaPrint aria-hidden="true" />
          {loading ? 'Checking...' : 'Go To Printable Copy'}
        </button>
      </div>

      {loading && <p className="printable-status">Resolving printable copy...</p>}
    </div>
  )
}

function NoPrintableState({ onClose, purpose }) {
  return (
    <div className="printable-unavailable-shell">
      <div className="printable-unavailable-card" role="status" aria-labelledby="printable-unavailable-title">
        <div className="printable-unavailable-icon" aria-hidden="true">
          <FaPrint />
        </div>
        <h2 id="printable-unavailable-title">Printable Not Available</h2>
        <p>
          A printable version is not yet set up for this invitation.
          Please contact our customer service to request or enable this feature.
        </p>
        {purpose && <div className="dashboard-feature-purpose">{purpose}</div>}
        <a
          className="printable-unavailable-primary"
          href="mailto:logicatechnology.dev@gmail.com?subject=Printable Invitation Request"
        >
          Contact Customer Service
        </a>
        {onClose && (
          <button className="printable-unavailable-secondary" onClick={onClose}>
            Back to Seat Checker
          </button>
        )}
      </div>
    </div>
  )
}
